import styled from 'styled-components';
import { pink600, shade700, spacing12, spacing20 } from '@pleo-io/telescope-tokens';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 14px;\n    color: ", ";\n    margin-bottom: ", ";\n\n    &:last-child {\n        margin-bottom: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    list-style-type: ", ";\n    list-style-position: inside;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    vertical-align: middle;\n    margin-top: -0.2em;\n    color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ListIcon = /*#__PURE__*/styled.div.attrs(function (_ref) {
  var size = _ref.size,
      color = _ref.color;
  return {
    size: size != null ? size : '1em',
    mr: 12,
    color: color != null ? color : pink600
  };
})( /*#__PURE__*/_templateObject(), pink600);
var listStyles = {
  number: 'decimal',
  bullet: 'disc',
  none: 'none'
};
var List = /*#__PURE__*/styled.ul.attrs({
  /**
   * Fix the Safari accessibility issue with list-style-type: none
   * @see https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html
   */
  role: 'list'
})( /*#__PURE__*/_templateObject2(), function (_ref2) {
  var _ref2$listStyle = _ref2.listStyle,
      listStyle = _ref2$listStyle === void 0 ? 'none' : _ref2$listStyle;
  return listStyles[listStyle];
});
var ListItem = /*#__PURE__*/styled.li( /*#__PURE__*/_templateObject3(), shade700, spacing12, spacing20);
export { List, ListIcon, ListItem };